import { useState, useEffect, useRef } from "react";
import { GetMocktestQuestion } from "../../../Client/request";

export const useReadingQuestion = (quest, onQuestionLoaded) => {
  const [questData, setQuestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modifiedTextValue, setModifiedTextValue] = useState("");
  const onQuestionLoadedRef = useRef(onQuestionLoaded);

  useEffect(() => {
    onQuestionLoadedRef.current = onQuestionLoaded;
  }, [onQuestionLoaded]);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      setQuestData(null);
      GetMocktestQuestion(quest?.QuestionId).then((res) => {
        if (res?.data) {
          setQuestData(res.data);
          setLoading(false);
          onQuestionLoadedRef.current?.();
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        console.error('Error fetching reading question:', error);
        setLoading(false);
      });
    }
  }, [quest]);

  useEffect(() => {
    if (questData?.QuestionStatement) {
      let newText = questData.QuestionStatement.replace(
        /%\{option_name\}/g,
        "#~#~#"
      )
        .replace(/#~#~#\./g, "#~#~# .")
        .replace(/\.#~#~#/g, ". #~#~#");

      setModifiedTextValue(newText);
    }
  }, [quest, questData]);

  return { questData, loading, modifiedTextValue };
};
